import Vue from 'vue'
import { getText as getPostTypeText } from "@/utils/enums/postTypeEnum";
import { getText as getPositionStatusText } from "@/utils/enums/positionStatusEnum";
import { formatDate } from "@/utils/utils";


Object.entries({
    getPostTypeText,
    getPositionStatusText,
    formatDate
}).forEach(([key, val]) => {
    Vue.filter(key, val);
})
